import React from 'react';
import { Box, Typography } from '@mui/material';
import PageIntro from 'components/PageIntro/PageIntro';

interface IAHeroProps {
  compact?: boolean;
}

const IAHero: React.FC<IAHeroProps> = ({ compact }) => {
  if (compact) {
    return (
      <Box>
        <Typography
          component={'h1'}
          sx={{
            fontSize: { xs: 22, md: 26 },
            fontWeight: 800,
            lineHeight: 1.15,
            mb: 0.5,
          }}
        >
          {'В дії'}
        </Typography>
        <Typography sx={{ color: 'text.secondary', fontSize: 15 }}>
          {'Перетворюй свій контент на слова для вивчення.'}
        </Typography>
      </Box>
    );
  }

  return (
    <PageIntro
      surface
      eyebrow={
        <Typography
          sx={{
            color: 'primary.main',
            fontSize: 12,
            fontWeight: 800,
            letterSpacing: '0.09em',
            textTransform: 'uppercase',
          }}
        >
          {'В дії'}
        </Typography>
      }
      title={'Вчи слова з контенту, який тобі справді цікавий'}
      description={
        'Встав транскрипт серії, статтю чи розділ книги — ми знайдемо нові слова, порівняємо з твоїм словником і перетворимо їх на набір для вивчення.'
      }
    />
  );
};

export default IAHero;
